import { createContext, useContext } from "react";
import { CoachStore } from "../Firestore/Coach";

const CoachStoreContext = createContext(new CoachStore());

export const useCoachStore = () => useContext(CoachStoreContext);

export default CoachStoreContext;
